import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { NavLinks } from "./NavLinks";

export function Header({ children }: { children?: ReactNode }) {
  return (
    <header className="mb-8">
      <div className="flex flex-wrap items-center gap-x-8 gap-y-4">
        <div className="group">
          <Link
            to="/"
            className="font-display text-4xl tracking-tight text-amber transition-colors hover:text-amber-warm"
          >
            Bandwith
          </Link>
          <div className="mt-2 h-0.5 w-20 origin-left bg-amber transition-transform duration-300 ease-out group-hover:scale-x-150" />
        </div>
        <NavLinks />
        <div className="order-2 ml-auto sm:order-3">{children}</div>
      </div>
    </header>
  );
}
